import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { IAccessories } from '@common-modules/product-catalogue';
import { mapAccessories } from '../../helpers/accessory';
import { updateAccessories } from '../../helpers/productDetails';
import { Accessory } from '../../types/accessory.types';
import { getUIAMEnabledWithToken } from '../../selectors';
import { AppState, KeyValue } from '../../types/common.types';

export const useAccessories = ({
  recommendedAccessories = [],
  accessories = []
}: {
  recommendedAccessories: string[];
  accessories: Accessory[];
}) => {
  const [formattedAccessories, setFormattedAccessories] = useState<
    IAccessories[] | undefined
  >();

  const { apigeeTokenEnabled, selectedAccessories } = useSelector<
    AppState,
    KeyValue
  >(state => {
    return {
      apigeeTokenEnabled: getUIAMEnabledWithToken(state),
      selectedAccessories: state.accessory?.selectedAccessories
    };
  });

  useEffect(() => {
    const setAccessories = async () => {
      let formattedAccessories = await mapAccessories(
        recommendedAccessories,
        accessories
      );
      if (selectedAccessories?.length) {
        formattedAccessories = updateAccessories(
          formattedAccessories,
          selectedAccessories
        );
      }
      setFormattedAccessories(formattedAccessories);
    };
    if (apigeeTokenEnabled) {
      setAccessories();
    }
  }, [apigeeTokenEnabled]);

  useEffect(() => {
    const updatedAccessories = updateAccessories(
      formattedAccessories,
      selectedAccessories
    );
    if (updatedAccessories) {
      setFormattedAccessories(updatedAccessories);
    }
  }, [selectedAccessories]);

  return {
    formattedAccessories,
    selectedAccessories
  };
};
